<template>
<div class="page_iteminfo page_shopcomment">
    <div class="comment">
        <div class="title">
            <span class="">全部评论</span>
            <span class="comment_num">{{ '('+ total +')' }}</span>
        </div>
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="con" v-for="item in dataList" :key="item.id">
                <div class="con_top clearfix">
                    <div class="f-l thumb">
                        <img :src="item.thumb ? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" alt="" class="thumb" />
                    </div>
                    <div class="f-l con_top_r">
                        <span class="user_name">{{ $publicData.formatPhone(item.name) }}</span>
                        <span class="time">{{ item.created_at }}</span>
                    </div>
                </div>
                <div class="con_nr">
                    <div class="yiji_txt">{{ item.content }}</div>
                    <div class="yiji_tu" v-if="(item.attr).length <=3 && (item.attr).length > 0">
                        <div class="tu_wrap" v-for="(imgTu, index) in item.attr" :key="index" @click="zhanshitupian(0,item.attr,index)">
                            <!-- <img :src="imgTu" alt="" class="tu" /> -->
                            <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+imgTu" />
                        </div>
                    </div>
                    <div class="yiji_tu" v-if="(item.attr).length > 3 && !show_more_tu">
                        <div class="tu_wrap" v-for="(imgTu, index) in item.attr.slice(0,3)" :key="index" @click="zhanshitupian(1,item.attr.slice(0,3),index)">
                            <!-- <img :src="imgTu" alt="" class="tu" /> -->
                            <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+imgTu" />
                            <div class="mark" v-if="index == 2 && !show_more_tu">{{'+'+ (item.attr.length -3)}}</div>
                        </div>
                    </div>
                    <div class="yiji_tu" v-if="(item.attr).length>3 && show_more_tu">
                        <div class="tu_wrap" v-for="(imgTu, index) in item.attr" :key="index" @click="zhanshitupian(0,item.attr,index)">
                            <!-- <img :src="imgTu" alt="" class="tu" /> -->
                            <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+imgTu" />
                        </div>
                    </div>
                </div>
            </div>
        </van-list>
    </div>
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            dataList: [],
            goodsId: this.$route.query.goodsId,
            goods: {},
            token: null,
            pages: {
                page: 1,
                size: 10
            },
            show_more_tu: false, // 加载更多图片，大于3张为真
            bigTuShow: false, // 大图预览
            bigTuIndex: 0, // 大图预览数组 初始索引
            bigTuImgArr: null, // 大图预览数组
            loading: true,
            finished: false,
            total: 0, // 总评论数
        }
    },
    components: {
        // PageSearch
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '全部评论',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                } else {
                    this.token = ''
                }
            })
            // 注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    methods: {
        // 获取列表
        getData() {
            var params = {
                token: this.token,
                good_id: this.goodsId,
                page: this.pages.page,
                size: this.pages.size
            }
            this.$api.shop.goodsComment(params).then(res => {
                if (res.code == 200) {
                    this.total = res.result.total
                    var list = res.result.comments
                    if (list.length == 0) {
                        // 数据全部加载完
                        this.finished = true
                        return;
                    }else{
						this.loading = false;
						this.pages.page++;
						for (var i in list) {
							this.dataList.push(list[i])
						};
					}
                } else {
                    this.$toast(res.message)
                    this.finished = true
                    return
                }
            })
        },
        // 展开大图   其中status用于判断 多于3张的图片，点击第3张加载更多，0 / 1 用于控制show_more_tu
        zhanshitupian(status, arr, index) {
            // console.log('点击放大图',arr)
			let customArr = [];
			for(let i in arr){
				customArr.push(this.imageUrl+arr[i]);
			};
            if (status == 1 && index == 2) {
                this.show_more_tu = true
                return;
            } else {
                this.bigTuImgArr = customArr;
                this.bigTuIndex = 0;
                this.bigTuShow = true;
            }
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
